import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Box, IconButton, Badge } from "@mui/material";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import { useAlerts } from "../../contexts/AlertContext";
import { useApp } from "../../hooks/useApp";
import { useSidebarData } from "./SidebarDataContext";
import NotificationPanel from "../../components/notifications/NotificationPanel";

const HIDDEN_ROUTES = [];

const Topbar = () => {
  const [notifAnchorEl, setNotifAnchorEl] = useState(null);
  const { unreadCount } = useAlerts();
  const { messageUser, proposalNotifications } = useApp();
  const { emailUnreadTotal } = useSidebarData();
  const { pathname } = useLocation();

  const newMessagesCount = messageUser.reduce(
    (sum, item) => sum + (item.countNewMessages || 0),
    0
  );
  const totalBadgeCount = (unreadCount || 0) + newMessagesCount + (proposalNotifications?.length || 0) + (emailUnreadTotal || 0);

  if (HIDDEN_ROUTES.some((r) => pathname.startsWith(r))) return null;

  return (
    <Box display="flex" justifyContent="flex-end" alignItems="center" gap={1} py={2} pl={2} pr="10px">
      <IconButton onClick={(e) => setNotifAnchorEl(e.currentTarget)}>
        <Badge badgeContent={totalBadgeCount} color="error" max={99}>
          <NotificationsOutlinedIcon sx={{ fontSize: 28 }} />
        </Badge>
      </IconButton>
      <NotificationPanel
        anchorEl={notifAnchorEl}
        onClose={() => setNotifAnchorEl(null)}
      />
    </Box>
  );
};

export default Topbar;
